import { TRUST_POINTS } from "@/data/content";
import { Check } from "lucide-react";

const PM_SYSTEMS = ["Dentrix", "Eaglesoft", "Open Dental"];

export function TrustBar() {
    return (
        <section className="border-y border-linec bg-stone2/50">
            <div className="max-w-[1240px] mx-auto px-6 lg:px-10 py-7 grid gap-6 lg:grid-cols-[1.5fr_1fr] items-center">
                <div className="flex flex-wrap gap-x-8 gap-y-3">
                    {TRUST_POINTS.map((t) => (
                        <div key={t} className="flex items-center gap-2 text-sm text-inksoft">
                            <Check size={15} className="text-terracotta shrink-0" />
                            {t}
                        </div>
                    ))}
                </div>
                <div className="flex flex-wrap gap-x-6 gap-y-2 lg:justify-end">
                    {PM_SYSTEMS.map((s) => (
                        <span key={s} className="font-mono text-xs uppercase tracking-[0.15em] text-sage/70">
                            {s}
                        </span>
                    ))}
                </div>
            </div>
        </section>
    );
}
